module.exports = __webpack_public_path__ + "img/headlineTxt.41cea62f.png";